import React, { useMemo, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { StyledIcon } from "../../../components/StyledIcon/StyledIcon";
import { CustomButtonVariant } from "../../../components/CustomButton/CustomButton";
import ScheduleDetailsModal from "../../../components/ScheduleDetailsModal/ScheduleDetailsModal";
import { TableRow } from "../models/defaut";
import { PipelineScheduleStatus } from "../../../modules/operational/models/GetPipelineSchedulesDTO";

interface RiverDetailsModalTableProps {
  row: TableRow;
}

const RiverDetailsModalTable: React.FC<RiverDetailsModalTableProps> = ({
  row,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const isEdit = useMemo(() => {
    const editableStatus = [
      PipelineScheduleStatus.INVOICE_PENDING,
      PipelineScheduleStatus.IN_SCHEDULING,
      PipelineScheduleStatus.IN_LOADING,
    ];
    return editableStatus.includes(row.statusText);
  }, [row.statusText]);

  const modalHeader = [
    { label: "Razão social", value: row.customer || "-", flex: 1 },
    { label: "N. do pedido", value: row.refId || "-" },
    { label: "Filial", value: row.subsidiary || "-" },
    { label: "Data do pedido", value: row.createdAt || "-" },
    { label: "Solicitado por:", value: row.customerRequester || "-" },
  ];

  const modalHighlightCards = [
    {
      items: [
        { label: "Transportadora", value: row.shippingCompany || "-" },
        { label: "Recebedor", value: row.receiver || "-" },
      ],
    },
    {
      items: [
        { label: "Data para carregamento", value: row.scheduleDate || "-" },
      ],
    },
  ];

  const modalDetails = [
    { label: "Produto", value: row.product || "-" },
    { label: "Modalidade", value: row.mod || "-" },
    { label: "Quantidade", value: `${row.quantity} ${row.unit}` },
    { label: "Condição de pagamento", value: row.paymentCondition || "-" },
  ];

  const modalFooter = {
    label: "Observação",
    value: row.customerRequesterNote || "-",
  };

  const actions = useMemo(() => {
    const items = [];

    if (isEdit) {
      items.push({
        label: "Editar",
        variant: CustomButtonVariant.DISABLED,
        onClick: () => {
          // TODO: modal de editar temporariamente desabilitado
        },
      });
    }

    items.push({
      label: "Fechar",
      variant: CustomButtonVariant.CONTAINED,
      onClick: handleClose,
    });

    return items;
  }, [isEdit]);

  return (
    <>
      <Tooltip title="Ver detalhes">
        <IconButton onClick={handleOpen}>
          <StyledIcon iconType="info" />
        </IconButton>
      </Tooltip>

      <ScheduleDetailsModal
        open={open}
        onClose={handleClose}
        title="Detalhes do pedido de agendamento"
        header={modalHeader}
        highlightCards={modalHighlightCards}
        details={modalDetails}
        footer={modalFooter}
        actions={actions}
      />
    </>
  );
};

export default RiverDetailsModalTable;
